/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Overall_ProgressInputs */



/**
* | output |
* | --- |
* | "Overall Progress" |
*
* @param {Embed_Captions_Overall_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_overall_progress = /** @type {((inputs?: Embed_Captions_Overall_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Overall_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Progression globale")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesamtfortschritt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progresso complessivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Общий прогресс")
	if (locale === "es") return /** @type {LocalizedString} */ ("Progreso general")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("总体进展")
	if (locale === "ja") return /** @type {LocalizedString} */ ("全体的な進捗")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समग्र प्रगति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Progresso geral")
	return /** @type {LocalizedString} */ ("Overall Progress")
});